export const MIN_ZOOM = 0.7;
export const MAX_ZOOM = 1.3;
export const REFRESH_PX = 7;
export const CANVAS_PADDING = 400;
export const CANVAS_TOP_PADDING = 300;
export const RECENTER_TRANSITION_MS = 300;
export const EDGE_BORDER_RADIUS = 15;
export const JUNCTION_GAP = 15;
export const CARD_EDGE_BEND_OFFSET = 10;

export const NODE_TYPES = {
  automationStep: 'automationStep',
  automationTrigger: 'automationTrigger',
  add: 'add',
  junction: 'junction',
  upload: 'upload',
  automationVariable: 'automationVariable',
  splitBranches: 'splitBranches',
  joinBranches: 'joinBranches',
  branchNode: 'branchNode',
  branchSplit: 'branchSplit',
  runSmartConnector: 'run_smartconnector',
  additionalVariables: 'additionalVariables',
  connection_initialize_additional_variables:
    'connection_initialize_additional_variables',
  connection_run_get_requests: 'connection_run_get_requests',
  transformAdd: 'transformAdd',
} as const;
